module.exports = __webpack_public_path__ + "media/components/shared/static/close-ceffbc294152966906adeb3e95ec4eeb.svg";